var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDocument = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.6 1.2V18h-6v6H2.2c-.66 0-1.2-.54-1.2-1.2V1.2C1 .54 1.54 0 2.2 0h19.2c.66 0 1.2.54 1.2 1.2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.6 18v6l6-6zM13 14.4c0-.66-.54-1.2-1.2-1.2H7c-.66 0-1.2.54-1.2 1.2s.54 1.2 1.2 1.2h4.8c.66 0 1.2-.54 1.2-1.2M17.8 8.4c0-.66-.54-1.2-1.2-1.2H7c-.66 0-1.2.54-1.2 1.2S6.34 9.6 7 9.6h9.6c.66 0 1.2-.54 1.2-1.2"
})));
export default SvgIcDocument;